import { useTranslations } from '@mentimeter/i18n';
import { Text } from '@mentimeter/ragnar-ui/text';
import { Button } from '@mentimeter/ragnar-ui/button';
import { Box } from '@mentimeter/ragnar-ui/box';
import { ErrorMessageWrapper } from './components/ErrorMessageWrapper';
import { ErrorMessageTitle } from './components/ErrorMessageTitle';

export const UnpaidInvoiceNoUpgrade = () => {
  const t = useTranslations('checkoutUiPackage');

  return (
    <ErrorMessageWrapper>
      <ErrorMessageTitle text={t('errors.unpaid_invoice_title')} />
      <Box gap="space5" alignItems="center">
        <Text textAlign="center" mt="space4" style={{ whiteSpace: 'pre' }}>
          {t('errors.unpaid_invoice_info')}
        </Text>
        <Button variant="primary" href="/app/billing">
          {t('errors.unpaid_invoice_CTA')}
        </Button>
      </Box>
    </ErrorMessageWrapper>
  );
};
